module.exports = __webpack_public_path__ + "static/img/bia-model@2x.ae237386.png";